<template>
  <div>

    <div class="d-flex justify-center flex-wrap">
      <v-card 
      v-for="ans in one.answers"
      :key="ans.id"
      max-width="300" class="mx-2">
        <v-img 
          height="120px" 
          :src="ans.pictureUrl" 
          :lazy-src="ans.pictureLazyUrl" 
          contain
        >
        </v-img>

        <v-card-actions class="justify-center align-center">
          <v-radio-group v-model="response" @change="$emit('save', {response, iso: one.iso})">
            <v-radio :value="ans.iso"  :label="ans.label"></v-radio>
          </v-radio-group>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    response: ''
  }),
  props: {
    cursor: Number,
    nbQuestions: Number,
    offerIso: String,
    one: Object
  },
  computed: {
    ...mapGetters('project', ['getResponse'])
  },
  mounted () {
    this.response = this.getResponse({iso: this.offerIso, question: this.one.iso})
  }
}
</script>